<template>
  <v-card style="min-height: 525px">
    <v-toolbar dense flat color="white">
      <v-btn icon absolute @click="backToProvince()" style="font-size: 32px">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <span style="font-size: 28px; font-weight: bold">SELECT DASHBOARD</span>
      <v-spacer />
    </v-toolbar>
    <v-layout row wrap justify-center class="pt-3">
      <v-flex
        xs12
        sm5
        v-if="'order' in permission && Object.keys(permission.order).length > 0"
      >
        <v-hover class="mb-3 mx-2">
          <v-card
            style="cursor: pointer"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            router-link
            @click="select('orderweserve')"
          >
            <v-layout wrap>
              <v-flex xs3 class="d-flex align-center justify-center">
                <v-icon style="font-size: 58px">dashboard</v-icon>
                <!-- <v-img
                  src="https://image.freepik.com/free-vector/hand-drawn-food-background_23-2148045413.jpg"
                  contain
                ></v-img> -->
              </v-flex>
              <v-flex xs9 class="pl-2">
                <v-card-title primary-title>
                  <div>
                    <h2>ORDER WESERVE</h2>
                    <div>Food delivery & Messenger</div>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex
        xs12
        sm5
        v-if="
          'order_wesmart' in permission &&
          Object.keys(permission.order_wesmart).length > 0
        "
      >
        <v-hover class="mb-3 mx-2">
          <v-card
            style="cursor: pointer"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            router-link
            :to="`/weserve_admin_login/orderwesmart/${$route.params.province}/orderlist/ordermade`"
          >
            <v-layout wrap>
              <v-flex xs3 class="d-flex align-center justify-center">
                <v-icon style="font-size: 58px">dashboard</v-icon>
                <!-- <v-img
                  src="https://image.freepik.com/free-vector/hand-drawn-food-background_23-2148045413.jpg"
                  contain
                ></v-img> -->
              </v-flex>
              <v-flex xs9 class="pl-2">
                <v-card-title primary-title>
                  <div>
                    <h2>ORDER WESMART</h2>
                    <div>Dashboard for order's rider</div>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
        </v-hover>
      </v-flex>
      <v-flex xs12 sm5>
        <v-hover class="mb-3 mx-2">
          <v-card
            style="cursor: pointer"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            router-link
            @click="select('control')"
          >
            <v-layout wrap>
              <v-flex xs3 class="d-flex align-center justify-center">
                <v-icon style="font-size: 58px">ballot</v-icon>
                <!-- <v-img
                  src="https://image.freepik.com/free-vector/background-food-sketches-kitchen-objects_23-2147596568.jpg"
                  contain
                ></v-img> -->
              </v-flex>
              <v-flex xs9 class="pl-2">
                <v-card-title primary-title>
                  <div>
                    <h2>CONTROL PANEL</h2>
                    <div>Application & Point of sale</div>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { instanceProvince } from "@/axios-path.js";
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      permission: (state) => state.permission,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      province: (state) => state.backOffice.province,
    }),
  },
  methods: {
    async select(info) {
      let isOrder = "";
      if (info == "orderweserve") {
        isOrder = "orderlist/ordermade";
      }

      this.$router.push({
        path:
          "/weserve_admin_login/" +
          info +
          "/" +
          this.$route.params.province +
          "/" +
          isOrder,
      });
    },
    backToProvince() {
      this.$router.push({ path: "/weserve_admin_login/select" });
    },
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: true,
        href: "/weserve_admin_login/select/",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
    this.$store.commit("backOffice/showMenu", null);
  },
  async created() {},
};
</script>

<style scoped>
.text-province {
  font-family: "GoldenPlains";
  font-size: 30px;
}
</style>
